package com.bikompanion.domain

data class StationWatchUpdate(
    val activeWatches: List<StationWatch>,
    val foundWatches: List<StationWatch> = emptyList(),
    val expiredWatches: List<StationWatch> = emptyList(),
)
